import {
  configureStore,
  combineReducers,
  getDefaultMiddleware,
} from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createFilter } from 'redux-persist-transform-filter'

import bookFormReducer from './bookForm/bookFormSlice'
import nowReducer from './now/nowSlice'
import webviewReducer from './webview/webviewSlice'
import utmReducer from './utm/utmSlice'
import selfConstructReducer from './selfConstruct/selfConstructSlice'
import cacheReducer from './cache/cacheSlice'
import pageLoadReducer from './pageLoad/pageLoadSlice'
import syDealCustomerVerifyReducer from './syDealCustomerVerify/syDealCustomerVerifySlice'
import sidReducer from './sid/sidSlice'
import featureToggleReducer from './featureToggle/featureToggleSlice'
import toastReducer from './toast/toastSlice'
import selfConstructFormReducer from './selfConstructBookForm/selfConstructFormSlice'

const syDealCustomerVeiryFilter = createFilter('syDealCustomerVerify', [
  'lastVerifyDate',
  'stopRemind',
  'showVerifyEntrance',
])

const cacheFilter = createFilter('cache', [
  'isFillUserInfoModalChecked',
  'authFromLocalbondChecked',
  'searchRecords',
])

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['bookForm', 'cache', 'syDealCustomerVerify'],
  transforms: [cacheFilter, syDealCustomerVeiryFilter],
}

const rootReducer = combineReducers({
  bookForm: bookFormReducer,
  selfConstructForm: selfConstructFormReducer,
  now: nowReducer,
  webview: webviewReducer,
  utm: utmReducer,
  selfConstruct: selfConstructReducer,
  cache: cacheReducer,
  pageLoad: pageLoadReducer,
  syDealCustomerVerify: syDealCustomerVerifyReducer,
  sid: sidReducer,
  featureToggle: featureToggleReducer,
  toast: toastReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  devTolls: process.env.APP_ENV !== 'prod',
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
})

export default store

export const persistor = persistStore(store)

export const selectRehydrated = (state) => state?._persist?.rehydrated
